import { isFileObject } from './isFileObject';
import { uploadFileToS3WithPresignedUrl } from './uploadToAWS';

export const resolveUpload = async (value: unknown) => {
  if (!value) return '';

  // ✅ already uploaded (API value)
  if (typeof value === 'string') return value;

  // ✅ new upload
  if (isFileObject(value)) {
    return uploadFileToS3WithPresignedUrl(value);
  }

  return '';
};
